export default __webpack_public_path__ + "assets/gallery.6f906656.svg";